
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import AddMessage from './add-message.vue';
import DetailMessage from './detail-message.vue';
import { getMsgList, editMsgStatus } from '@/api/exchange-code';
import { toast } from '@/utils/common';
@Component({
  components: { AddMessage, DetailMessage },
  filters: {
    yyyy_mm_dd_two(val: number) {
      return moment(val * 1000).format('YYYY/MM/DD HH:mm:ss');
    },
    client_type(val: string) {
      let client: string = '';
      if (!val) {
        return client;
      }
      if (val.indexOf('1') > -1) {
        client += ' PC端';
      }
      if (val.indexOf('2') > -1) {
        client += ' 安卓端';
      }
      return client;
    },
  },
})
export default class extends Vue {
  private dataValue: Date[] = [];
  private messageTable: any[] = [];
  private loading: boolean = true;
  private total: number = 0;
  messageDialog: boolean = false;
  detailsDialog: boolean = false;
  msgId: number = 0;
  messageDetails = {};
  private searchValue: {
    start: number;
    end: number;
    search_key: string;
    page: number;
    page_size: number;
  } = {
    start: 0,
    end: 0,
    search_key: '',
    page: 1,
    page_size: 30,
  };
  dataChange(datavalue: Date[]) {
    if (!datavalue) {
      this.searchValue.start = 0;
      this.searchValue.end = 0;
      this.searchValue.page = 1;
      this.getMessageList();
      return;
    }
    this.searchValue.start = Math.floor(datavalue[0].getTime() / 1000);
    this.searchValue.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.searchValue.page = 1;
    this.getMessageList();
  }
  searchList() {
    this.searchValue.page = 1;
    this.getMessageList();
  }
  addMessage() {
    this.messageDialog = true;
    this.msgId = 0;
  }

  seeDetails(row: any) {
    // this.messageDetails = row;
    this.msgId = row.id;
    this.messageDialog = true;
  }
  getUserId(id: any, maxNum: number) {
    if (!id) {
      return;
    }
    if (id.length === 0) {
      return '全体';
    }
    // let idArr = id.map((item: any) => {
    //   item = 'D' + item;
    //   return item;
    // });
    // return idArr.join(',');
    let value: string = '';
    let len = id.length > maxNum ? maxNum : id.length;
    for (let i = 0; i < len; i++) {
      if (i != 0) {
        value += ',';
      }
      value += 'D' + id[i];
    }
    value = id.length > maxNum ? value + '...' : value;
    return value;
  }
  switchChange(row: any) {
    //关闭
    if (!row.status) {
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: '是否确认关闭此消息推送？',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            this.loading = true;
            this.openOffMessageNotice(row);
            done();
            instance.confirmButtonLoading = false;
          } else if (action === 'cancel') {
            row.status = true;
            done();
          }
        },
      }).then(action => {
        //done();
      });
      return;
    } else {
      // 开启
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: '是否确认开启此消息推送？',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            this.loading = true;
            this.openOffMessageNotice(row);
            done();
            instance.confirmButtonLoading = false;
          } else if (action === 'cancel') {
            row.status = false;
            done();
          }
        },
      }).then(action => {
        //done();
      });
      return;
    }
  }
  handleSizeChange(page_size: number) {
    this.searchValue.page = 1;
    this.searchValue.page_size = page_size;
    this.getMessageList();
  }
  handleCurrentChange(page: number) {
    this.searchValue.page = page;
    this.getMessageList();
  }
  /**
   * 设置默认时间
   */
  getTimeFn() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.dataValue = [start, end]; // 默认
    this.searchValue.start = Math.round(new Date(this.formatDate(start) + ' 00:00:00').getTime() / 1000);
    this.searchValue.end = Math.round(new Date(this.formatDate(end) + ' 23:59:59').getTime() / 1000);
    this.getMessageList();
  }
  /**
   * 格式化时间
   */
  formatDate(date: Date) {
    let myyear: string | number = date.getFullYear();
    let mymonth: string | number = date.getMonth() + 1;
    let myweekday: string | number = date.getDate();

    if (mymonth < 10) {
      mymonth = '0' + mymonth;
    }
    if (myweekday < 10) {
      myweekday = '0' + myweekday;
    }
    return myyear + '-' + mymonth + '-' + myweekday;
  }
  addMessageSuccess(status: boolean) {
    if (status) {
      this.getMessageList();
    }
  }
  async getMessageList() {
    this.loading = true;
    try {
      const res = await getMsgList(this.searchValue);
      this.loading = false;
      if (res) {
        this.messageTable = res.data.list;
        this.total = res.data.total;
      }
      //
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }
  // 开启通知消息
  async openOffMessageNotice(row: any) {
    this.loading = true;
    try {
      const res = await editMsgStatus(row.id, { status: row.status });
      if (res.code == 0) {
        this.getMessageList();
      } else {
        toast(res.msg, 'info');
        row.status = !row.status;
      }
      //
    } catch (err) {
      console.log(err);
      row.status = !row.status;
    } finally {
      this.loading = false;
    }
  }
  mounted() {
    // this.getTimeFn();
    this.getMessageList();
  }
}
